import Stack from '@mui/material/Stack';

import { PaymentMethod } from '../../../../../../contracts';
import { useExpressComponents } from '../hooks/use-express-components';

interface ExpressComponentsRendererProps {
  paymentMethods?: PaymentMethod[];
  onComponentsReady: (isComponentsAvailable: boolean) => void;
}

export function ExpressComponentsRenderer({
  paymentMethods,
  onComponentsReady,
}: ExpressComponentsRendererProps) {
  const { expressComponents, handleComponentReady } = useExpressComponents(
    onComponentsReady,
    paymentMethods
  );

  return (
    <Stack spacing={1}>
      {expressComponents.map(({ Component, key }) => (
        <Component
          key={key}
          onReady={(isAvailable: boolean) => handleComponentReady(key, isAvailable)}
        />
      ))}
    </Stack>
  );
}
